export default function PageHeader({ eyebrow, title, description, image }) {
  return (
    <section
      data-testid="page-header"
      className="relative overflow-hidden bg-[#0F172A]"
    >
      {image && (
        <>
          <div
            className="absolute inset-0 bg-cover bg-center opacity-40"
            style={{ backgroundImage: `url(${image})` }}
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#0F172A]/95 via-[#0F172A]/80 to-[#0F172A]/40" />
        </>
      )}
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-20 md:py-28">
        {eyebrow && (
          <div className="rk-eyebrow !text-[#67e8c4]">{eyebrow}</div>
        )}
        <h1 className="mt-4 font-display text-4xl sm:text-5xl lg:text-6xl font-extrabold text-white tracking-tight max-w-3xl">
          {title}
        </h1>
        {description && (
          <p className="mt-5 text-base sm:text-lg text-slate-300 max-w-2xl">
            {description}
          </p>
        )}
      </div>
    </section>
  );
}
